import {
  Button,
  IconButton,
  TextField,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import { Grid } from "@material-ui/core";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import DownloadIcon from "@mui/icons-material/Download";
import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Add_update_quotation from "./add_update_quotation";
import { GetAllQuotationList } from "../../redux/API/api_quotation";
import SnackbarCustom from "../../components/Snackbar/Snackbar";
import GreenSignal from "../../assets/images/GreenSignal.jpg";
import RedSignal from "../../assets/images/RedSignal.jpg";
import YellowSignal from "../../assets/images/YellowSignal.jpg";

export default function Quotation() {
  const statusMapping = {
    1: { text: "In process / New", img: RedSignal },
    2: { text: "Drawing Pending with AW – design", img: YellowSignal },
    3: { text: "Drawing submitted / Completed", img: GreenSignal },
  };

  const columns = [
    {
      field: "actions",
      headerName: "Quotation Referance No",
      flex: 0.5,
      sortable: false,
      width: "20px",
      gap: "20px",

      renderCell: (params) => (
        <div>
          <span
            style={{ cursor: "pointer", color: "blue" }}
            onClick={() => handleEditQuotation(params.row)}
          >
            {params.row.quotationRefNo}
          </span>
        </div>
      ),
    },
    { field: "customerName", headerName: "Customer Name", width: 200 },
    { field: "initiatorName", headerName: "Inititator Name", width: 300 },
    { field: "SubmittedOn", headerName: "Submit Date", width: 200 },
    {
      field: "status",
      headerName: "Status",
      flex: 0.5,
      sortable: false,
      width: "60px",
      gap: "20px",

      renderCell: (params) => {
        const statusCode = statusMapping[params.row.status] || {};
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <img
              src={statusCode.img}
              alt={statusCode.text}
              width="20"
              height="20"
            />
            <span>{statusCode.text}</span>
          </div>
        );
      },
    },
  ];

  const [rows, setRows] = useState();
  const [initialRows, setInitialRows] = useState([]);
  const [editQuotation, setEditQuotation] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [alertType, setAlertType] = useState("");

  const userdetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData
  );
  const siteToken = useSelector((state) => state.saveTokenReducer);
  const azureToken = useSelector((state) => state.saveAzureTokenReducer);

  const [selectedValues, setSelectedValues] = useState({
    refno: "",
    initiator: "",
    customer: "",
  });

  useEffect(() => {
    getTableData(false);
  }, []);

  const handleChange = (field, value) => {
    setSelectedValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleSnackOpen = (text, type) => {
    setSnackMessage(text);
    setAlertType(type);
    setOpen(true);
  };

  // fileting data based on the input global search
  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchText(value);
    const filteredRows = initialRows.filter((row) =>
      Object.values(row).some((field) =>
        field ? field.toString().includes(value) : ""
      )
    );
    setRows(filteredRows);
  };

  // table data search clear
  const clearSearch = () => {
    setSearchText("");
    setRows(initialRows);
  };

  // snackbar close
  const handleClose = (e) => {
    setOpen(false);
  };

  // getting user list
  function getTableData(isSearch) {
    setIsLoader(true);
    let inp = {};
    if (!isSearch) {
      inp.refno = "";
      inp.initiator = "";
      inp.customer = "";
      setSelectedValues({
        refno: "",
        initiator: "",
        customer: "",
      })
    } else {
      inp = selectedValues;
    }

    GetAllQuotationList(
      siteToken,
      azureToken.token,
      userdetails.userId,
      userdetails.userEmail,
      userdetails.gid,
      userdetails.roleName,
      userdetails.roleId,
      inp
    )
      .then((response) => {
        setInitialRows(response.map((item, i) => ({ id: i + 1,
          SubmittedOn : response[i].submittedOn.split('T')[0] || '',
           ...item })));
        setRows(response.map((item, i) => ({ id: i + 1, 
          SubmittedOn : response[i].submittedOn.split('T')[0] || '',
          ...item })));
        setIsLoader(false);
      })
      .catch((error) => {
        console.log("Error: " + error, "error");
        setIsLoader(false);
      });
  }

  const handleEditQuotation = (users) => {
    setEditQuotation(users);
    setOpenDialog(true);
  };

  // opening user dialog when  user clicks on add button
  const handleAddQuotation = useCallback(() => {
    setEditQuotation(null);
    setOpenDialog(true);
  }, []);

  // downloding data in excel
  const exportToExcel = () => {
    let ExcelData = [];
    for (let i = 0; i < rows.length; i++) {
      let input = {};
      input.SrNo = i + 1;
      input.Quotation_Ref_No = rows[i].quotationRefNo;
      input.Customer_Name = rows[i].customerName;
      input.Initiator_Name = rows[i].initiatorName;
      input.Submit_Date = rows[i].SubmittedOn.split('T')[0] || '';
      if (rows[i].status == 1){
        input.status = 'In process / New';
      }
      if (rows[i].status == 2){
        input.status = 'Drawing Pending with AW – design';
      }
      if (rows[i].status == 3){
        input.status = 'Drawing submitted / Completed';
      }
      
      ExcelData.push(input);
    }
    const worksheet = XLSX.utils.json_to_sheet(ExcelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Quotation Master");
    XLSX.writeFile(workbook, "QuotationList.xlsx");
  };

  const commonInputStyle = {
    width: "50%",
    padding: "7px",
    marginTop: "14px",
    marginLeft: "8px",

    "& .MuiInputBase-root": {
      fontSize: "12px",
      height: "45px",
    },
  };

  return (
    <Box sx={{ padding: "10px", border: "1px solid #ccc" }}>
      <h4 style={{ marginTop: "10px", fontWeight: "bold", fontSize: "18px" }}>
        Quotation
      </h4>

      <Grid container spacing={3} style={{ marginTop: "5px", padding: "8px" }}>
        <TextField
          sx={{ commonInputStyle }}
          label={
            <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
              Quotation Referance No.
            </span>
          }
          name="refno"
          value={selectedValues.refno}
          variant="outlined"
          onChange={(e) => handleChange("refno", e.target.value)}
        />

        <TextField
          sx={{ commonInputStyle }}
          style={{ marginLeft: "15px" }}
          label={
            <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
              Initiator Name
            </span>
          }
          name="initiator"
          value={selectedValues.initiator}
          variant="outlined"
          onChange={(e) => handleChange("initiator", e.target.value)}
        />
        <TextField
          sx={{ commonInputStyle }}
          style={{ marginLeft: "15px" }}
          label={
            <span style={{ fontSize: "0.90rem", fontWeight: 400 }}>
              Customer Name
            </span>
          }
          name="customer"
          value={selectedValues.customer}
          variant="outlined"
          onChange={(e) => handleChange("customer", e.target.value)}
        />

        <Grid item xs={12} sm={6} md={6} style={{ maxWidth: "none" }}>
          <div>
            <Button
              className="btn"
              variant="contained"
              onClick={() => getTableData(true)}
            >
              Search
            </Button>
            <span style={{ marginLeft: "20px" }}>
              <Button
                className="btn"
                variant="contained"
                onClick={() => getTableData(false)}
              >
                Reset
              </Button>
            </span>
          </div>
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px",
        }}
      >
        <SearchIcon color="action" />
        <TextField
          variant="standard"
          placeholder ='Search'
          value={searchText}
          onChange={handleSearch}
          sx={{ marginLeft: "5px", width: "400px" }}
        ></TextField>
        <IconButton onClick={clearSearch} size="small">
          <ClearIcon fontSize="small"/>
        </IconButton>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
            width: "100%",
          }}
        >
          <Tooltip title="Download excel">
            <IconButton size="small" onClick={exportToExcel}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
          <Button
            variant="contained"
            className="pt-button--primary"
            onClick={handleAddQuotation}
          >
            Add Quotation
          </Button>

          <Add_update_quotation
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            editQuotation={{ editQuotation }}
          />
        </Box>
      </Box>
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSizeOptions={[10, 15, 20]}
          initialState={{
            pagination: { paginationModel: { pageSize: 10 } },
          }}
          getRowId={(row) => row.id}
          loading={isLoader}
          disableRowSelectionOnClick
          localeText={{
            noRowsLabel: "No Matching Records Found!",
          }}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#d3d3d3",
              fontWeight: "500",
              fontSize: "13px",
              color: "black",
              lineHeight: "1.5rem",
            },
            "& .MuiDataGrid-columnHeader": { backgroundColor: "#d3d3d3" },

            "& .MuiDataGrid-cell": { textAlign: "left", fontSize: "12px" },
            "& .MuiDataGrid-footerContainer": {
              border: "1px solid #000",
              fontSize: "12px",
            },
            "& .MuiDataGrid-virtualScroller": {
              scrollbarWidth: "none",
              "& ::-webkit-scrollbar": { display: "none" },
            },
          }}
        />

        <>
          <SnackbarCustom
            open={open}
            message={snackMessage}
            alertType={alertType}
            handleClose={handleClose}
          />
        </>
      </div>
    </Box>
  );
}
